import { useId } from "react";
import { RadioGroupContext } from "$contexts/RadioGroupContext";

export const RadioGroup = ({children, name}) => {

    const id = useId();
    name = name ?? id;

    return (
        <RadioGroupContext value={{name}}>
            {children}
        </RadioGroupContext>
    )
}